<div class="white-box">
    <div id="userReportsContainer" [hidden]="!appConstant.isReport" [style.height.px]="reportHeight">     
    </div>
    <div class="iframe-container" [hidden]="appConstant.isReport">
      <iframe [src]="appConstant.insightMenusafeSrc" [style.height.px]="reportHeight" width="100%"></iframe>
   </div>
  </div>